import { formatCurrency } from '@habity/utils';
import { DataFieldConfig, forEstateTypes } from './data-builder';

export const associationFields: DataFieldConfig[] = [
  {
    key: 'association.name',
    label: 'Namn',
    estateTypes: forEstateTypes('HousingCooperative'),
  },

  {
    key: 'association.genuineAssociation',
    label: 'Äkta förening',
    estateTypes: forEstateTypes('HousingCooperative'),
    condition: (context) => {
      const value = context.filteredProviderData?.association?.genuineAssociation;
      return value !== undefined && value !== null;
    },
    formatter: (value) => value ? 'Ja' : 'Nej',
  },

  {
    key: 'association.theAssociationOwnTheGround',
    label: 'Föreningen äger marken',
    estateTypes: forEstateTypes('HousingCooperative'),
    condition: (context) => {
      const value = context.filteredProviderData?.association?.theAssociationOwnTheGround;
      if (typeof value === 'string') {
        const cleanValue = value.trim();
        return cleanValue !== '';
      }
      return value !== null && value !== undefined;
    },
    formatter: (value) => 
       value === 'Föreningen äger marken' ? 'Ja' : value,
  },

  {
    key: 'association.numberOfApartments',
    label: 'Antal lägenheter',
    estateTypes: forEstateTypes('HousingCooperative'),
    condition: (context) => {
      const value = context.filteredProviderData?.association?.numberOfApartments;
      return value && value > 0;
    },
  },

  {
    key: 'association.numberOfRentalUnits',
    label: 'Antal uthyrningsenheter',
    estateTypes: forEstateTypes('HousingCooperative'),
    condition: (context) => {
      const value = context.filteredProviderData?.association?.numberOfRentalUnits;
      return value && value > 0;
    },
  },

  {
    key: 'association.numberOfLocals',
    label: 'Antal lokaler',
    estateTypes: forEstateTypes('HousingCooperative'),
    condition: (context) => {
      const value = context.filteredProviderData?.association?.numberOfLocals;
      return value && value > 0;
    },
  },

  {
    key: 'association.generalAboutAssociation',
    label: 'Allmänt om föreningen',
    estateTypes: forEstateTypes('HousingCooperative'),
  },

  {
    key: 'association.homePage',
    label: 'Hemsida',
    estateTypes: forEstateTypes('HousingCooperative'),
  },

  {
    key: 'association.parking',
    label: 'Parkering',
    estateTypes: forEstateTypes('HousingCooperative'),
  },

  {
    key: 'association.transferFee',
    label: 'Överlåtelseavgift och pantsättning',
    estateTypes: forEstateTypes('HousingCooperative'),
    condition: (context) => {
      const transferFee = context?.filteredProviderData?.association?.transferFee;
      const pledgeFee = context?.filteredProviderData?.association?.pledgeFee;
      return (transferFee && transferFee > 0) || (pledgeFee && pledgeFee > 0);
    },
    formatter: (value, context) => {
      const pledgeFee = context?.filteredProviderData?.association?.pledgeFee;
      return `En överlåtelseavgift tas ut om ca ${formatCurrency(
        value
      )} som betalas av ${context?.filteredProviderData?.association?.transferFeePaidBy === 'Säljare' ? 'säljaren' : 'köparen'}. Vid belåning av bostaden tas en pantsättningsavgift ut om ca ${formatCurrency(
        pledgeFee
      )}/pant. Beloppen är beräknade på prisbasbeloppet för år ${new Date().getFullYear()}.`;
    },
  },
];
